function calc() {
    // Калькулятор

    let fas = '1', wood = 'dub', ton = '1', result = '1-dub-1';
    const calcImg = document.querySelectorAll('.calculator__img img');

    function  calcTotal() {
      
      result = `${fas}-${wood}-${ton}`;
      showImage();
    }
  
    calcTotal(); 

    
    function showImage() {
      calcImg.forEach(item => {
        item.classList.add('none');
        if (item.dataset.calc == result) {
          item.classList.remove('none');
          item.classList.add('block');
        }
      });
    }
  
    function getStaticInfo(selector) {
      const elements = document.querySelectorAll(selector);
  
      elements.forEach(elem => {
        elem.addEventListener('click', (e) => {
          if (e.target.getAttribute('data-fas')) {
            fas = String(e.target.getAttribute('data-fas'));
          } else if (e.target.getAttribute('data-wood')) {
            wood = String(e.target.getAttribute('data-wood'));
          } else if (e.target.getAttribute('data-ton')) {
            ton = String(e.target.getAttribute('data-ton'));
          }
    
          calcTotal();
        });
      });
    }
  
    getStaticInfo('[name="fas"]');
    getStaticInfo('[name="wood"]');
    getStaticInfo('[name="ton"]');
  
}

export default calc;